import {SystemStatusGroup} from "../../../../../core/gd/const/system-status";


export const PORTFOLIO_SUMMARY_DEFAULT_SETTINGS = {
    columns             : _.map(['2','6','22','27','25','24','23'], id=>({id: id/*, aggregate: null*/})), // portfoio special!
    systemStatusFilter  : SystemStatusGroup.OPEN, // used is task table to show hide archived tasks
    sortBy              : null,  // current sort by column value
    sorting             : null,  // current sort by column value
    filters             : {},
}


//
// export default {
//     columns             : _.map(['2','6','22','27','25','24','23'], id=>({id: id/*, aggregate: null*/})), // portfoio special!
//     systemStatusFilter  : 'open', // used is task table to show hide archived tasks
//     sortBy              : null,  // current sort by column value
//     filters             : {},
// }
